import { Instance } from 'mobx-state-tree';
import { CheckVerificationCodeResponseDtoModelBase } from './CheckVerificationCodeResponseDtoModel.base';

/* The TypeScript type of an instance of CheckVerificationCodeResponseDtoModel */
export interface CheckVerificationCodeResponseDtoModelType extends Instance<typeof CheckVerificationCodeResponseDtoModel.Type> {}

/* A graphql query fragment builders for CheckVerificationCodeResponseDtoModel */
export { selectFromCheckVerificationCodeResponseDto, checkVerificationCodeResponseDtoModelPrimitives, CheckVerificationCodeResponseDtoModelSelector } from './CheckVerificationCodeResponseDtoModel.base';

/**
 * CheckVerificationCodeResponseDtoModel
 */
export const CheckVerificationCodeResponseDtoModel = CheckVerificationCodeResponseDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
